/*
    创建者：shuxiaokai
    创建时间：2019-08-01 14:02
    模块名称：基于quill的富文本编辑器（废弃）
    备注：xxxx
*/
<template>
    <div>
        <div ref="s-editor"></div>
        <input ref="file" type="file" name="file" hidden accept="image/*">
    </div>
</template>

<script>
import Quill from "quill"
import "quill/dist/quill.snow.css"

import request from "@/api/api.js"
import { BaseConfig } from "@/config.default"
export default {
    props: {
        value: {
            type: String,
            default: ""
        },
        options: {
            type: Object,
            default() {
                return {
                    imgSize: 1024 * 3
                }
            }
        }
    },
    data() {
        return {
            editorInstance: null,
            content: "",
            toolbar: [
                ["bold", "italic", "underline", "strike"],
                // ["blockquote", "code-block"],
                // [{ header: 1 }, { header: 2 }],
                // [{ list: "ordered" }, { list: "bullet" }],
                // [{ script: "sub" }, { script: "super" }],
                // [{ indent: "-1" }, { indent: "+1" }],
                // [{ direction: "rtl" }],
                // [{ size: ["1", false, "large", "huge"] }],
                // [{ header: [1, 2, 3, 4, 5, 6, false] }],
                [{ color: [] }],
                // [{ font: [] }],
                // [{ align: [] }],
                // ["clean"],
                ["link", "image"]
            ],
            uploadPicUrl: process.env.NODE_ENV === "development" ? BaseConfig.devImgUrl : BaseConfig.proImgUrl,
            currentEditorIndex: 0,
        };
    },
    mounted() {
        this.initEditor();
    },
    methods: {
        initEditor() {
            /*eslint no-undef: off*/
            this.editorInstance = new Quill(this.$refs["s-editor"], {
                theme: "snow",
                modules: {
                    toolbar: this.toolbar,
                },
                placeholder: "请输入相关内容..."
            });
            //=====================================设置默认值====================================//
            if (this.value) {
                this.editorInstance.pasteHTML(this.value);
            }
            //=====================================添加自定义行为====================================//
            this.addCustomImgUpload();
            this.addCustomLink();
            //=====================================监听事件，改变值====================================//
            this.editorInstance.on("text-change", (delta, oldDelta, source) => {
                const htmlValue = this.$refs["s-editor"].children[0].innerHTML;
                const textValue = this.editorInstance.getText();
                if (this.content === "<p><br></p>") {
                    this.content = "";
                } //全部为换行的时候自动消除内容
                this.content = htmlValue;
                this.$emit("input", this.content);
                this.$emit("change", { htmlValue, textValue });
            });
            this.$emit("ready", this.editorInstance);
        },
        //=====================================添加自定义数据处理====================================//
        /* 
            @description  自定义图片上传
            @autor        shuxiaokai
            @create       2019-08-02 10:44"
        */
        addCustomImgUpload() {
            const toolBar = this.editorInstance.getModule("toolbar");
            toolBar.addHandler("image", () => {
                this.currentEditorIndex = this.editorInstance.getSelection().index;
                this.$refs["file"].click();
            });
            this.$refs["file"].addEventListener("change", (e) => {
                const file = e.target.files[0];
                const formData = new FormData();
                formData.append("file", file)
                request.axios.post(this.uploadPicUrl, formData).then(res => {
                    this.editorInstance.insertEmbed(this.currentEditorIndex, "image", res.data);
                }).catch(err => {
                    console.error(err);
                })
            })
        },
        /* 
            @description  自定义url链接
            @autor        shuxiaokai
            @create       2019-08-02 10:44"
        */
        addCustomLink() {
            const toolBar = this.editorInstance.getModule("toolbar");
            toolBar.addHandler("link", () => {
                this.currentEditorIndex = this.editorInstance.getSelection().index;
                const delta = this.editorInstance.getContents();
                console.log(delta)
                this.editorInstance.format("link", "aaaa")
                this.editorInstance.insertText(this.currentEditorIndex, "<a href='#'>百度</a>")
            });
        }
    }
};
</script>



<style lang="scss">
    .ql-editor {
        min-height: 300px;
    }
</style>
